module.exports = __webpack_public_path__ + "img/img_67.c74a474f.png";